// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".base-section{background-color:#fff;clip:rect(auto,auto,auto,auto)}", ""]);
// Exports
module.exports = exports;
